import LabelAnnotation from '../../models/LabelAnnotation';
import { reportUtils } from '@/features/report/lib/reportUtils';

export default class AnnotationDetailsTextBuilder {

    /**
     * @param {LabelAnnotation} annotation 
     */
    constructor(annotation) {
        /** @type {LabelAnnotation} */
        this.annotation = annotation;
    }

    /**
     * @returns {string}
     */
    build() {
        if (!this.annotation)
            return '';
        return [
            this.buildLocalizacaoDentes(),
            this.buildLocalizacaoRegioesAnatomicas(),
            this.buildQualificadores(),
        ].filter(text => text).join(' | ');
    }

    buildLocalizacaoDentes() {
        if (!this.annotation.localizacao || !this.annotation.localizacao.dentes)
            return '';

        const dentes = this.annotation.localizacao?.dentes || [];
        // Pego apenas do primeiro dente, pois na selecao do popup todos os dentes sao selecionados juntos
        const porcoes = dentes.slice(0, 1).map(dente => dente.porcoes)
            .flat()
            .map(this.mapTermToReportText);
        const faces = dentes.slice(0, 1).map(dente => dente.faces)
            .flat()
            .map(this.mapTermToReportText);

        let porcoesTextoListagem = reportUtils.getListReportText(porcoes);
        let porcoesTextoFinal = porcoesTextoListagem;
        let facesTextoListagem = reportUtils.getListReportText(faces);
        let facesTextoFinal = facesTextoListagem;
        const temAmbosTipos = facesTextoListagem.length > 0 && porcoesTextoListagem.length > 0;

        // Se tiver os dois tipos, eu coloco prefixo para facilitar a leitura
        // if (temAmbosTipos) {
        //     if (porcoes.length > 0) {
        //         const temMultiplos = porcoes.length > 1;
        //         porcoesTextoFinal = `${temMultiplos ? 'porções' : 'porção'} ${porcoesTextoFinal}`;
        //     }
        //     if (faces.length > 0) {
        //         const temMultiplos = faces.length > 1;
        //         facesTextoFinal = `${temMultiplos ? 'faces' : 'face'} ${facesTextoFinal}`;
        //     }
        // }

        if (this.annotation.localizacao.especificacaoInterna == 'interno__porcao_extensao') {
            if (porcoes.length > 0) {
                // Uso apenas a porcao mais proxima a apical
                const ordemPorcoes = [
                    'apical',
                    'média',
                    'cervical'
                ];
                const porcaoMaisProximaApical = porcoes
                    .sort((a, b) => ordemPorcoes.indexOf(a) - ordemPorcoes.indexOf(b))[0];
                // Sempre tem prefixo para juntar com o texto de extensao
                // if (!temAmbosTipos) {
                // porcoesTextoFinal = `${temMultiplos ? 'porções' : 'porção'} ${porcoesTextoFinal}`;
                // }
                porcoesTextoFinal = `se extende até a porção ${porcaoMaisProximaApical}`;
            }

        } else if (this.annotation.localizacao.especificacaoInterna == 'interno__porcao_antes_da_face') {
            // Porcao primeiro
            return [porcoesTextoFinal, facesTextoFinal].filter(text => text).join(' | ');
        }

        // Faces primeiro como default
        return [facesTextoFinal, porcoesTextoFinal].filter(text => text).join(' | ');
    }

    buildLocalizacaoRegioesAnatomicas() {
        if (!this.annotation.localizacao || !this.annotation.localizacao.regioesAnatomicas)
            return '';
        const regioesAnatomicas = this.annotation.localizacao?.regioesAnatomicas || [];
        const porcoes = regioesAnatomicas.map(regiao => [...(regiao.porcoes || [])])
            .flat()
            .map(this.mapTermToReportText);

        let porcoesTextoListagem = reportUtils.getListReportText(porcoes);
        let especificacaoTexto = '';
        const especificacaoReport = reportUtils.getEspecificacaoReport(this.annotation.localizacao.especificacaoInterna);
        if (especificacaoReport && especificacaoReport.posicao == 'depois') {
            especificacaoTexto = especificacaoReport.texto.singular;
        }

        return [porcoesTextoListagem, especificacaoTexto].filter(text => text).join(' | ');
    }

    buildQualificadores() {
        if (!this.annotation.qualificadores)
            return '';
        let qualificadores = this.annotation.qualificadores || [];
        // TODO: Temporariamente deixando todos qualificadores na mesma linha (tanto NEW_LINE quanto SAME_LINE)
        // qualificadores = qualificadores.filter(qualificador => qualificador.format == 'SAME_LINE');

        return reportUtils.getListReportText(
            qualificadores
                .map(qualificador => qualificador.label || qualificador.text)
                .map(this.mapTermToReportText)
        );
    }

    /**
     * @param {string} term 
     * @returns {string}
     */
    mapTermToReportText(term) {
        return {
            'coroa__incisal': 'incisal',
            'coroa__oclusal': 'oclusal',
            'coroa__cervical': 'cervical',
            'coroa__mesial': 'mesial',
            'coroa__distal': 'distal',
            'raiz__distal': 'distal',
            'raiz__mesial': 'mesial',
            'raiz__cervical': 'cervical',
            'raiz__apical': 'apical',
            'raiz__media': 'média',
            'dente_completo__coroa': 'coroa',
            'dente_completo__raiz': 'raiz',
            'media': 'média',
        }[term] || term;
    }

}